import Vue from 'vue'

Vue.filter('digit', function (value, digits) {
  if(value === undefined)
    value = 0;

  if(digits === undefined)
    digits = 2;

  const num = Number(value);
  return num.toLocaleString('de-DE', { minimumFractionDigits: digits, maximumFractionDigits: digits});
})
